module.exports = __webpack_public_path__ + "fb6b78414bc81fe44be4bcace13d295d.svg";